import React, { useRef, useEffect, useState } from "react"
import { Link } from "gatsby"

const SpeakerIcon = ({ muted }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 9.5v5h3.5l4.5 4V5.5l-4.5 4H4z" fill="currentColor" stroke="none" />
    {muted ? (
      <path d="M17 9.5l5 5M22 9.5l-5 5" />
    ) : (
      <>
        <path d="M15.8 8.7a5 5 0 0 1 0 6.6" />
        <path d="M18.6 6.3a9 9 0 0 1 0 11.4" />
      </>
    )}
  </svg>
)

const absoluteFillStyle = {
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  width: "100%",
  height: "100%",
}

export default ({ item, index }) => {
  if (!item.node.content || item.node.content?.length < 1) return null

  const inputEl = useRef(null)

  const playVideo = () => {
    if (inputEl.current) inputEl.current.play().catch(() => {})
  }

  const stopVideo = () => {
    if (inputEl.current) inputEl.current.pause()
  }

  const thumbnail = item.node.thumbnail || item.node.content[0]
  const [muted, setMuted] = useState(true)

  useEffect(() => {
    if (inputEl.current) {
      inputEl.current.muted = muted
    }
  }, [muted])

  const isVideo = !thumbnail.fixed
  const galleryUrl = `/gallery/${item.node.slug}`
  const isAboveFold = index < 3
  const lazy = !isAboveFold

  const content = isVideo ? (
    <>
      <video
        ref={inputEl}
        playsInline
        muted
        loop
        preload="metadata"
        className="grid-video grid-video--desktop"
        style={{ ...absoluteFillStyle, objectFit: "cover" }}
      >
        <source src={thumbnail.file.url} type="video/mp4" />
      </video>
      <video
        playsInline
        autoPlay
        loop
        muted
        preload="metadata"
        className="grid-video grid-video--mobile"
        style={{ ...absoluteFillStyle, objectFit: "cover" }}
      >
        <source src={thumbnail.file.url} type="video/mp4" />
      </video>
    </>
  ) : (
    <img
      src={thumbnail.fixed.src}
      alt={item?.node?.title}
      loading={lazy ? "lazy" : "eager"}
      decoding={lazy ? "async" : "auto"}
      fetchpriority={isAboveFold ? "high" : undefined}
      style={{ ...absoluteFillStyle, objectFit: "cover" }}
    />
  )

  return (
    <div className="portfolio-card">
      <div className="portfolio-card__media">
        <Link
          to={galleryUrl}
          className="project-link"
          onMouseEnter={playVideo}
          onMouseLeave={stopVideo}
          onFocus={playVideo}
          onBlur={stopVideo}
        >
          <div
            style={{
              position: "relative",
              aspectRatio: "3 / 2",
              overflow: "hidden",
              background: "rgba(23,23,21,0.04)",
            }}
          >
            <div className="project-image" style={{ ...absoluteFillStyle, position: "absolute" }}>
              {content}
            </div>
          </div>
        </Link>
        {isVideo && (
          <button
            type="button"
            className="grid-mute-toggle"
            aria-label={muted ? "Unmute project video" : "Mute project video"}
            onClick={() => setMuted(!muted)}
          >
            <SpeakerIcon muted={muted} />
          </button>
        )}
      </div>
      <Link to={galleryUrl} className="project-meta">
        <strong>{item.node.title}</strong>
        <span>
          View <span aria-hidden="true">↗</span>
        </span>
      </Link>
    </div>
  )
}
